var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLefticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    viewBox: "0 0 6.321 10.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.3,10.6,0,5.273,5.3,0,6.321,1.031,2.115,5.273,6.321,9.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLefticon);
export default __webpack_public_path__ + "static/media/left.icon.defab1f9aa509d36c8381b2fd583eb6f.svg";
export { ForwardRef as ReactComponent };